import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
const steps = [{
  num: '1',
  title: 'Identifica',
  desc: 'Descubre qué situaciones específicas disparan tu enojo mediante nuestro inventario de gatillos.'
}, {
  num: '2',
  title: 'Interrumpe',
  desc: 'Aplica el Escudo de 3 Segundos en el momento de tensión para recuperar tu centro.'
}, {
  num: '3',
  title: 'Conecta',
  desc: 'Sustituye el grito por consecuencias lógicas y comunicación de autoridad tranquila.'
}];
export const HowItWorks = () => {
  return <Section className="bg-white" data-id="element-112">
      <div className="text-center mb-16" data-id="element-113">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-charcoal mb-4" data-id="element-114">
          Cómo funciona el método
        </h2>
        <p className="text-lg text-charcoal/70" data-id="element-115">
          Un proceso de 3 pasos simple y efectivo.
        </p>
      </div>

      <div className="relative max-w-4xl mx-auto" data-id="element-116">
        {/* Connecting line for desktop */}
        <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-beige -z-10" data-id="element-117"></div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-6" data-id="element-118">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="flex flex-col items-center text-center relative" data-id="element-119">
              <div className="w-24 h-24 rounded-full bg-cream border-4 border-white shadow-soft flex items-center justify-center mb-6 relative z-10" data-id="element-120">
                <span className="text-4xl font-serif font-bold text-terracotta" data-id="element-121">
                  {step.num}
                </span>
              </div>
              <h3 className="text-2xl font-serif font-semibold text-charcoal mb-4" data-id="element-122">
                {step.title}
              </h3>
              <p className="text-charcoal/70 leading-relaxed px-4" data-id="element-123">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </Section>;
};